module.exports = __webpack_public_path__ + "img/bigwin-text.f6061d08.png";